// extracted by mini-css-extract-plugin
export default {"channel-home__empty":"styles_channel-home__empty__St0Fw"};